const NAME = "APP";

export default NAME;
